// Local answer grading — same normalisation rules as the worker.
// Used for instant UI feedback; the worker re-grades authoritatively.

import type { DailyItem } from "./types";

export function normaliseAnswer(s: string): string {
  return s
    .trim()
    .toLowerCase()
    .replace(/[áàäâã]/g, "a")
    .replace(/[éèëê]/g, "e")
    .replace(/[íìïî]/g, "i")
    .replace(/[óòöôõ]/g, "o")
    .replace(/[úùüû]/g, "u")
    .replace(/[^\p{L}\p{N}\s]/gu, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function gradeLocally(
  item: DailyItem,
  userAnswer: string,
): { correct: boolean; correctAnswer: string } {
  const u = normaliseAnswer(userAnswer);
  if (item.kind === "el_la") {
    return {
      correct: u === item.correct_article,
      correctAnswer: `${item.correct_article} ${item.lemma}`,
    };
  }
  if (item.kind === "conj") {
    return {
      correct: u === normaliseAnswer(item.correct_form),
      correctAnswer: item.correct_form,
    };
  }
  // vocab — exact match only; anything fuzzier defers to the server
  const match = item.answers.some((a) => normaliseAnswer(a) === u);
  return { correct: match, correctAnswer: item.answers[0] ?? "" };
}
